define((require) => {
    "use strict";

    const Queue = require("shared/services/sync/Queue");

    /**
     * @class {ParallelQueue}
     * A <i>parallel queue</i> describes a number of (potentially) parallel sync requests, without any specific
     * correlation between synced targets (though the same target instance can be queued numerous times, thus blocking
     * itself). Unlike a <i>sequential queue</i>, each sync request will be started immediately, and the queue promise
     * will resolve once all (parallel) requests have completed. If all enqueued target entities are distinct, all
     * requests will execute in parallel. <p>
     *
     * Unless a result handler is supplied at construction time, the queue will resolve to each target synced, in
     * queuing order.
     *
     * @author Gunni Rode / <a href="http://www.zmags.com">Zmags</a>
     *
     * @see    SequentialQueue
     * @see    TargetQueue
     */
    return Queue.extend("ParallelQueue", {

        _enqueue(enqueue, options, targets, args) {
            // We create and start targets queues immediately for each queued entry, for all indices, so future sync
            // requests can know which targets are currently being synced/queued. Each created entry thus stores a
            // reference to the target queue used to sync the target in question...
            return enqueue(targets, (queue, target) => { // this queue!
                const tq = queue.manager.queue(target); // must create target queue at enqueue time for possible future requests!
                const promise = tq.enqueue(options, args);

                // Start each target queue now, if not already!
                tq.sync();

                return {
                    promise() { return promise; },
                    sync() {
                        tq.sync(); // for re-starts, needed?
                        return promise;
                    },
                    cancel() { return tq.cancelEntry(promise.entry); }, // cancel from our entry and forward, since followers will depend on it...
                    toString() { return `${queue.id}:${queue.size()}[${promise.entry}]`; }
                };
            });
        }
    });
});



// WEBPACK FOOTER //
// ./src/shared/services/sync/ParallelQueue.js